module.exports = __webpack_public_path__ + "static/media/half.628abd89.jpg";